import { MetricsKind } from "../types";
import { SIMPLE_SUM } from "./simple-sum";
import { roundValue, safeParseFloat } from "lib/number";

export const AVERAGE_DEPTH = ({ factoryOptions, getterParams }) => {
    // Get plan row units
    const unitsFactoryOptions = { ...factoryOptions, metric: { kind: MetricsKind.UNITS } };
    const unitsPlanRows = SIMPLE_SUM({ factoryOptions: unitsFactoryOptions, getterParams });

    // Get plan row products
    const productsFactoryOptions = { ...factoryOptions, metric: { kind: MetricsKind.PLAN_ROWS } };
    const productsPlanRows = SIMPLE_SUM({ factoryOptions: productsFactoryOptions, getterParams });

    const averageDepth = safeParseFloat(unitsPlanRows / productsPlanRows, 0);
    return roundValue(averageDepth, 1);
};
